import { Scribe } from "./..";
import { appendMetaVersion } from "../meta";
// Must use require as `import` statement may reconstruct build output
// See: https://stackoverflow.com/questions/51070138/how-to-import-package-json-into-typescript-file-without-including-it-in-the-comp
var pkg = require("../../../../package.json");

/**
 * @name CoreMetadata
 * @description A JavaScript object representing the core metadata.
 * @namespace
 */
export var CoreMetadata = {
  /**
   * Applies package metadata to the `window._att_version` property.
   * @function init
   * @memberof window
   * @returns {void}
   */
  init: function init() {
    Scribe.log('Assigning Attuned Core metadata to global _att_version', pkg.version);
    appendMetaVersion(pkg.version, pkg.name);
  }
};